<template>
	<div style="padding-top: 85px;">
		<!-- 导航栏 -->
		<headerList></headerList>
		
		<!-- banner部分 -->
		<div class="music-banner flex-dir-col flex-y-c flex-x-s">
			<p class="c-ff f-38">为创意注入BGM 用听觉感动</p>
			<div class="search-box mt-25 flex">
				<!-- 分类下拉 -->
				<div class="search-cate flex-c pl-35">
					<span class="f-16 c-33 mr-15">{{name}}</span>
					<!-- <span class="f-16 c-99 iconfont iconxiangxiajiantou"></span> -->
				</div>
				<input class="flex-box search-input plr-15 f-16" v-model="search" placeholder="近期新增525首，搜索发现更多" @keyup.enter="bindmusicList(0)" />
				<div class="search-btn flex-c" @click="bindsearch">
					<span class="iconfont iconsearch f-18 c-ff"></span>
					<span class="f-18 ml-5 c-ff">搜索</span>
				</div>
			</div>
			<!-- 关键词 -->
			<div class="mt-10 flex-c">
				<span class="mlr-10 f-16 c-ff">关键词: </span>
				<span class="mlr-10 f-16 c-ff music-keys" v-for="item in search_key" @click="enterSearch('SYS_TOPIC_cn',item)" :key="item">{{item}}</span>
				
			</div>
		</div>
		
		<div class="bg-f5 music-list-box">
			<p class="t-c f-16 c-33">音乐TOP榜</p>
			<div class="mt-15 flex-c">
				<div class="music-list-cate  t-c" :class="cats==item.id?'active':''" v-for="item in music_cate" :key="item.id" @click="bindlinkTo('/music_list?cats=' + item.id, item.title)">{{item.title}}</div>
			</div>
			<div class="music-list flex flex-x-s flex-wrap">
				<div class="music-detail-box mt-25 bg-ff flex flex-y-s p-20" v-for="item,index in music_list" :key="index" @click="toImgdetail(item.docId,item.doclibId)">
					<!-- 左侧图片 -->
					<div class="left-box mr-20">
						<div class="img-box relative"> <img :src="item.COVERPATH" alt="" class="detail-img-big" /></div>
						<div class="img-bof relative">
							<div class="img-bof-bg"></div>
							<img :src="item.COVERPATH" class="absolute" alt="">
							<!-- 开始暂停图标 -->
							<div class="absolute icon-box">
								<!-- <span class="iconfont iconbofang-zanting c-ff f-16"></span> -->
								<!-- <span class="iconfont iconbofangzanting c-ff f-16"></span> -->
							</div>
						</div>
					</div>
					<!-- 右侧信息 以及按钮 -->
					<div class="flex-box flex-dir-col flex-x-b" style="height: 100%;">
						<p class="onelist c-33 f-16">{{item.docName}}</p>
						<div class="onelist f-14 c-99" style="margin-top: -10px;">格式： mp3， Wav</div>
						<div class="flex">
							<!-- <span class="iconfont iconbofang f-24 c-99" @click="musicEndorBegin(index,item.isPlay)"></span> -->
							<!-- <div class="mlr-10  music-bar"> -->
								<!-- <span></span> -->
								<!-- <audio preload="none" :id="'audio'+index" @canplay="getDuration(index)" @timeupdate="timeupdate" :ref="'audio'+index">
								   <source src="../assets/1.mp3" type="audio/mpeg">
								</audio> -->
							<!-- </div> -->
							<!-- <span class="f-14 c-33">00:00</span> -->
						</div>
						<!-- 下载收藏操作 -->
						<div class="flex">
							<div class="flex-box mr-10 download-btn f-18 t-c">下载配乐</div>
							<div class="coll-btn flex-c"><span class="iconfont iconcollection_2 c-a5 f-18"></span></div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 分页 -->
			<div class="mt-50 t-c f-12 c-99">没有搜索到合适配乐？换个关键词试试~</div>
			<div class=" flex-c pt-25">
				<Page class-name="page-class" :total="total" :page-size="24" @on-change="changePage" />
			</div>
		</div>
		
		<footer-view></footer-view>
	</div>
</template>

<script>
import headerView  from './header.vue'
import footerView  from './footer.vue'
import headerList  from './header_nav.vue'
export default {
  data () {
    return {
			nav_list: [],
			music_list: [], // 音频列表
			totalPages: 0, // 数据总页数
			total: 0, // 数据总条数
			cats: 0,
			name: '',
			search: '',
			music_cate: [] ,// 分类
			search_key: []
		}
  },

	components: {
		headerView,
		footerView,
		headerList
	},
	
  created () {
		let _this = this
		
		_this.cats = _this.$route.query.cats
		_this.name = _this.$route.query.name
		document.title=this.$route.query.name
		
		this.bindMusiccate()
		// this.bindNavlist()
		this.bindmusicList(0) // 音频列表
		
		this.bindSearch()
	},

  methods: {	 
		 // 跳转到音频详情
		 toImgdetail (id,tid) {
		 	// this.$router.push({path: '/audio_detail', query: {id,tid}})
			let link = this.$router.resolve({
				path:'/audio_detail',
				query:{ id,tid }
			});
			window.open(link.href, "_blank"); //打开新窗口
		 },
		 // 获取关键字
		 async bindSearch () {
		 			 let _this = this
		 			 const res = await _this.get_res('/search/getHotWords',{size:5,sld: "AHSCXB"})
		 			 if (res.length) {
		 				 _this.search_key = res
		 			 }
		 },
		 
		 // 进入搜索页面
		 enterSearch (field,q) {
		 	if (q=='') {
		 		return this.$Message.warning('请输入具体内容');
		 	}
		 	this.$router.push({path: '/search_list',query:{field,q}})
		 },
		 
		 // 控制音频播放与否
		 musicEndorBegin (index,state) {
			 let id = 'audio' + index
			 let _this = this
			 let audio = document.getElementById(id)
			 if (audio !== null) {
				 if (state) {
					 audio.pause()
				 } else {
					 audio.play()
				 }
				 let obj = _this.music_list[index]
				 obj.isPlay = !state
				 _this.music_list.splice(index, 1, obj)
			 }
		 },
		 
			// 跳转
			bindlinkTo (path,name) {
				if (path == '') {
					return
				}
				this.$router.push({path,query: {name}})
			},
			
			// 获取音频列表
			async bindmusicList (page=0) {
				 let _this = this
				 _this.$Spin.show()
				 let data = {}
				 if (_this.search != '') {
					 data.field = "SYS_TOPIC_cn"
					 data.q = _this.search
				 }
				 data.cats = _this.cats
				 data.size = 24
				 data.page = page
				 data.t = 28
				 data.sld = "AHSCXB"
				 data.sort = "SYS_LASTMODIFIED_dt,desc"
				 const res = await _this.get_res('/search',data)
				 _this.music_list = res.content
				 _this.totalPages = res.totalPages
				 _this.total = res.totalElements
				 _this.$Spin.hide()
			},
			
			changePage (page) {
				this.bindmusicList(page-1)
			},
			
			// 获取音频的分类
			async bindMusiccate () {
				let _this = this
				const res = await _this.get_res('/cats?sld=AHSCXB&docLibId=28&parentId=6241-28', {})
				res.forEach(x => {
					let index_2 = x.text.lastIndexOf("'")
					let index_1 = x.text.indexOf("'")
					x.title = x.text.substring(index_1+1, index_2)
				})
				_this.music_cate = res
			},
			
			async bindsearch () {
				let _this = this
				_this.$Spin.show()
				// if (_this.search == '') {
				// 	return _this.$Message.warning('请输入相关内容')
				// }
				let data = {
						field: 'SYS_TOPIC_cn',
						q: _this.search,
						size: 24,
						page: 0,
						sld:'AHSCXB',
						sort:'SYS_LASTMODIFIED_dt,desc',
						cats: _this.cats
					}
				const res = await _this.get_res('/search', data )
				_this.music_list = res.content
				_this.$Spin.hide()
			}
		 
	},
	
	// 监听器监听路由的变化
	watch: {
		'$route'(to,from) {
			let _this = this
			_this.search = ''
			_this.cats = _this.$route.query.cats
			_this.name = _this.$route.query.name
			// 做一些路由变化的响应
			this.bindmusicList(0)
		}
	},
	
	beforeDestroy () {
		document.title= '图片安徽'
	},
}
</script>

<style lang="less" scoped>


.music-banner {
	width: 100%;
	height: 610px;
	background: url(../assets/images/music-banner.jpg) no-repeat center;
	background-size: 100% 100%;
	padding-top: 90px;
	.search-box {
		width: 800px;
		height: 55px;
		border-radius: 55px;
		overflow: hidden;
	}
	.search-cate {
		width: 120px;
		height: 55px;
		border-right: 1px solid #999999;
		background: rgba(255,255,255,.8);
	}
	.search-input {
		height: 55px;
		background: rgba(255,255,255,.8);
	}
	.search-btn {
		width: 120px;
		height: 55px;
		background-image: linear-gradient(270deg, #FD9383 0%, #FA328B 100%);
	}
}
.music-keys {
	transition: all .5s;
}
.music-keys:hover {
	color: #FA328C;
	cursor: pointer;
}

// 图片列表分类
.music-list-cate {
	width: 95px;
	height: 32px;
	border-radius: 16px;
	background-color: #fff;
	transition: all .3s;
	cursor: pointer;
	margin: 0 8px;
	line-height: 32px;
	color: #333;
}
.music-list-cate:hover, .active.music-list-cate{
	color: #fff;
	background-image: linear-gradient(270deg, #FD9383 0%, #FA328B 100%);
}

// 音乐详情盒子
.music-list .music-detail-box:nth-child(4n) {
	margin-right: 0;
}
.music-detail-box {
	width: 345px;
	height: 190px;
	margin-right: 20px;
	box-shadow: 0 0px 2px rgba(0, 0, 0, 0.1);
	transition: all .3s;
	border-radius: 4px;
	cursor: pointer;
	.left-box {
		width: 120px;
		.img-box {
			width: 120px;
			height: 100px;
			border-radius: 4px;
			overflow: hidden;
		}
		// .img-box::before {
		// 	position: absolute;
		// 	top: 0;
		// 	left: 0;
		// 	width: 100%;
		// 	height: 100%;
		// 	content: '';
		// 	z-index: 1;
		// 	background-color: rgba(0, 0, 0, 0.15);
		// }
		.img-bof {
			width: 98px;
			height: 98px;
			margin: -49px auto 0;
			img {
				width: 46%;
				height: 46%;
				border-radius: 50%;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				z-index: 1;
			}
			.icon-box {
				top: 50%;
				left: 50%;
				z-index: 2;
				transform: translate(-50%, -50%);
			}
		}
	}
	// 以上是详情的图片样式
	.coll-btn {
		width: 36px;
		height: 36px;
		border-radius: 3px;
		border: 1px solid #e5e5e5;
	}
	.download-btn {
		height: 36px;
		border: 1px solid #7165e1;
		border-radius: 3px;
		color: #7165e1;
		line-height: 36px;
	}
}
.music-detail-box:hover {
	box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.15);
}

.music-list-box {
	padding: 60px 0;
}
.music-list {
	width: 1440px;
	margin: 0 auto;
}

// 进度条 
.music-bar {
	flex: 1;
	position: relative;
	height: 4px;
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.05);
	span {
		width: 0;
		display: block;
		position: relative;
		height: 4px;
		border-radius: 4px;
		background-color: #7265E2;
	}
	span::after {
		content: '';
		position: absolute;
		right: -5px;
		top: -4px;
		width: 10px;
		height: 10px;
		display: block;
		background-color: #7265E2;
		border-radius: 10px;
	}
}


// 音乐详情;两种图片
.detail-img-big {
	width: 100%;
	height: 100%;
	// -webkit-filter: blur(5px);
	// -moz-filter: blur(5px);
	// -ms-filter: blur(5px);
	// filter: blur(5px);
	// filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=6, MakeShadow=false);
	// filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='6', MakeShadow='true', ShadowOpacity='0.3');
}
.img-bof-bg {
	position: relative;
	z-index: 1;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: url(../assets/images/audiopan.png) no-repeat center / 100%;
	-webkit-transform: rotate(360deg);
	animation: rotation 20s linear infinite;
	-moz-animation: rotation 20s linear infinite;
	-webkit-animation: rotation 20s linear infinite;
	-o-animation: rotation 20s linear infinite;
	animation-play-state: paused;
	-webkit-animation-play-state: paused;
}
</style>
